import React from 'react';
import { connect } from 'react-redux';
import { showOptionalTermsOfUse } from '../actions/termsOfUse';
import vsLogo from '../images/VeroSource-logo.png';
import {
  TOU_LINK_EN, TOU_LINK_FR,
  PRIVACY_LINK_EN, PRIVACY_LINK_FR,
  FAQ_LINK_EN, FAQ_LINK_FR,
  HELP_LINK_EN, HELP_LINK_FR,
} from '../globals/settings';

import { DISABLE_HEADER_FOOTER } from "../globals/settings"
import { isInIFrame } from "../util/util"

class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      TOU_LINK: '',
      PRIVACY_LINK: '',
      FAQ_LINK: '',
      HELP_LINK: '',
    }
  }

  componentDidMount(){
    if(this.props.language === 'en'){
      this.setState({ TOU_LINK: TOU_LINK_EN, PRIVACY_LINK: PRIVACY_LINK_EN, FAQ_LINK: FAQ_LINK_EN, HELP_LINK: HELP_LINK_EN });
    } else{
      this.setState({ TOU_LINK: TOU_LINK_FR, PRIVACY_LINK: PRIVACY_LINK_FR, FAQ_LINK: FAQ_LINK_FR, HELP_LINK: HELP_LINK_FR });
    }
  }

  componentDidUpdate(prevProps){
    if(prevProps.language !== this.props.language){
      if(this.props.language === 'en'){
        this.setState({ TOU_LINK: TOU_LINK_EN, PRIVACY_LINK: PRIVACY_LINK_EN, FAQ_LINK: FAQ_LINK_EN, HELP_LINK: HELP_LINK_EN });
      } else{
        this.setState({ TOU_LINK: TOU_LINK_FR, PRIVACY_LINK: PRIVACY_LINK_FR, FAQ_LINK: FAQ_LINK_FR, HELP_LINK: HELP_LINK_FR })
      }
    }
  }

  getFooterText() {
    return (
      <div className="col-7">
        <div className="leftFooter mt-3"><a className='footer-tou' onClick={() => this.props.dispatch(showOptionalTermsOfUse())}>{this.props.strings.TOU}</a>  |  <a href={this.state.PRIVACY_LINK}>{this.props.strings.PRIVACY}</a>  |  <a href={this.state.FAQ_LINK}>{this.props.strings.FAQ}</a></div>
        <div className="leftFooterMobile mt-3"><a className='footer-tou' onClick={() => this.props.dispatch(showOptionalTermsOfUse())}>{this.props.strings.TOU}</a>  |  <a href={this.state.PRIVACY_LINK}>{this.props.strings.PRIVACY}</a>  |  <a href={this.state.FAQ_LINK}>{this.props.strings.FAQ}</a></div>
      </div>
    )
  }

  render() {
      if(DISABLE_HEADER_FOOTER){
        return null;
      }

      return (
        <div className="footer">
          <div className="container-fluid">
            <div className="row">
              {this.getFooterText()}
              <div className="col-5">
                <div className="vsLogo"><img src={vsLogo} alt="VeroSource Solutions Inc." width="125"/></div>
              </div>
              <div className="col-12">
                <p className="mt-2">{this.props.strings.NB_COPYRIGHT}</p>
              </div>
            </div>
          </div>
        </div>
      );
  }
}

const mapStateToProps = (state, ownProps) => {
    return {
        language: state.language.language,
        strings: state.language.strings,
    }
}
const ConnectedFooter = connect(
    mapStateToProps,
)(Footer);
export default ConnectedFooter;
